export default __webpack_public_path__ + "static/media/overall_icon.912414d5.svg";